import { NgModule } from '@angular/core';
import { FiInputMaskDirective } from './fi-input-mask.directive';

@NgModule({
    declarations: [FiInputMaskDirective],
    exports: [FiInputMaskDirective],
})
export class FiInputMaskModule {}
